<p-toast></p-toast>

<div class="profile-layout">

    <!-- ── Scrollable content ── -->
    <div class="profile-scroll">
        @if (user) {
        <form [formGroup]="profileForm">

            <!-- ── Avatar header ── -->
            <div class="profile-header">
                <div class="profile-avatar-wrap" (click)="photoInput.click()" [title]="isUploadingPhoto ? 'Uploading...' : 'Click to change photo'">
                    @if (photoUrl) {
                    <img [src]="photoUrl" alt="Profile photo" class="profile-avatar-img" />
                    } @else {
                    <p-avatar
                        [label]="initials"
                        size="xlarge"
                        shape="circle"
                        [style]="{'background-color': user.colorCode || 'var(--color-primary-500)', 'color': '#fff'}">
                    </p-avatar>
                    }
                    <div class="profile-avatar-overlay">
                        @if (isUploadingPhoto) {
                        <span class="profile-avatar-icon">&#8987;</span>
                        } @else {
                        <svg class="profile-avatar-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z"/><path d="M9 2 7.17 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3.17L15 2H9Zm3 15a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"/></svg>
                        }
                    </div>
                </div>
                <input #photoInput type="file" accept="image/jpeg,image/png,image/gif,image/webp,image/heic,image/heif" style="display:none" (change)="onPhotoSelected($event)" />
                <div class="profile-header-info">
                    <h3 class="profile-name">{{ user.firstName }} {{ user.lastName }}</h3>
                    <span class="profile-role-badge">{{ user.roleName }}</span>
                </div>
            </div>

            <!-- ── Identity ── -->
            <div class="skid-section">
                <h4 class="skid-section-title">Identity</h4>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label class="modal-label">First Name <span class="req">*</span></label>
                        <input pInputText formControlName="firstName" placeholder="First name" class="w-full"
                            [class.p-invalid]="f['firstName'].invalid && f['firstName'].touched" />
                        @if (f['firstName'].invalid && f['firstName'].touched) {
                        <small class="modal-error">
                            @if (f['firstName'].errors?.['required']) { First name is required. }
                            @if (f['firstName'].errors?.['minlength']) { Minimum 3 characters. }
                        </small>
                        }
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Last Name <span class="req">*</span></label>
                        <input pInputText formControlName="lastName" placeholder="Last name" class="w-full"
                            [class.p-invalid]="f['lastName'].invalid && f['lastName'].touched" />
                        @if (f['lastName'].invalid && f['lastName'].touched) {
                        <small class="modal-error">
                            @if (f['lastName'].errors?.['required']) { Last name is required. }
                            @if (f['lastName'].errors?.['minlength']) { Minimum 3 characters. }
                        </small>
                        }
                    </div>
                    <div class="col-12">
                        <label class="modal-label">Email</label>
                        <input pInputText formControlName="email" class="w-full" />
                    </div>
                </div>
            </div>

            <!-- ── Account ── -->
            <div class="skid-section">
                <h4 class="skid-section-title">Account</h4>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Role</label>
                        <input pInputText formControlName="roleName" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">User Type</label>
                        <input pInputText formControlName="userTypeName" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Status</label>
                        <input pInputText formControlName="status" class="w-full" />
                    </div>
                </div>
            </div>

            <!-- ── Contact ── -->
            <div class="skid-section">
                <h4 class="skid-section-title">Contact</h4>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Phone Number <span class="req">*</span></label>
                        <input pInputText formControlName="phoneNumber" placeholder="Phone number" class="w-full"
                            [class.p-invalid]="f['phoneNumber'].invalid && f['phoneNumber'].touched" />
                        @if (f['phoneNumber'].invalid && f['phoneNumber'].touched) {
                        <small class="modal-error">
                            @if (f['phoneNumber'].errors?.['required']) { Phone number is required. }
                            @if (f['phoneNumber'].errors?.['maxlength']) { Cannot exceed 20 characters. }
                        </small>
                        }
                    </div>
                </div>
            </div>

            <!-- ── Work Address ── -->
            <div class="skid-section">
                <h4 class="skid-section-title">Work Address</h4>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Address 1</label>
                        <input pInputText formControlName="address1" placeholder="Address line 1" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Address 2</label>
                        <input pInputText formControlName="address2" placeholder="Address line 2" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">City <span class="req">*</span></label>
                        <input pInputText formControlName="city" placeholder="City" class="w-full"
                            [class.p-invalid]="f['city'].invalid && f['city'].touched" />
                        @if (f['city'].invalid && f['city'].touched) {
                        <small class="modal-error">City is required.</small>
                        }
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">State <span class="req">*</span></label>
                        <input pInputText formControlName="state" placeholder="State" class="w-full"
                            [class.p-invalid]="f['state'].invalid && f['state'].touched" />
                        @if (f['state'].invalid && f['state'].touched) {
                        <small class="modal-error">State is required.</small>
                        }
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Zip Code</label>
                        <input pInputText formControlName="zip" placeholder="Zip code" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Country</label>
                        <input pInputText formControlName="country" placeholder="Country" class="w-full" />
                    </div>
                </div>
            </div>

        </form>
        }
        @else {
        <div class="profile-loading">
            <p>Loading profile...</p>
        </div>
        }
    </div>

    <!-- ── Docked footer ── -->
    <div class="profile-footer">
        <button type="button" class="modal-btn-primary" (click)="saveProfile()" [disabled]="isSaving || !user">
            {{ isSaving ? 'Saving...' : 'Save' }}
        </button>
    </div>

</div>
